import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LineStyleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"line_style"}/>
}
